// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Competition from "./competition.js"
import Survey from "./survey.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "competition_id": {
      "column": {
        "default": null,
        "name": "competition_id",
        "null": false,
        "type": "uuid"
      },
      "name": "competition_id",
      "selected_by_default": null,
      "translated": null
    },
    "for_individuals": {
      "column": {
        "default": true,
        "name": "for_individuals",
        "null": false,
        "type": "boolean"
      },
      "name": "for_individuals",
      "selected_by_default": null,
      "translated": null
    },
    "for_teams": {
      "column": {
        "default": true,
        "name": "for_teams",
        "null": false,
        "type": "boolean"
      },
      "name": "for_teams",
      "selected_by_default": null,
      "translated": null
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": "uuid"
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "icon_path": {
      "column": null,
      "name": "icon_path",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "CompetitionSurvey",
  "collectionKey": "competition_surveys",
  "collectionName": "competition_surveys",
  "i18nKey": "competition_survey",
  "camelizedLower": "competitionSurvey",
  "name": "CompetitionSurvey",
  "nameDasherized": "competition-survey",
  "pluralName": "competition_surveys",
  "ransackable_associations": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "belongs_to",
      "resource_name": "Competition",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "icon_file_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "icon_file_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "icon_file_attachment"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "competition_id",
      "column": {
        "default": null,
        "name": "competition_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "for_individuals",
      "column": {
        "default": true,
        "name": "for_individuals",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "for_teams",
      "column": {
        "default": true,
        "name": "for_teams",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_competition_id",
      "column": {
        "default": null,
        "name": "old_competition_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_survey_id",
      "column": {
        "default": null,
        "name": "old_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "belongs_to",
      "resource_name": "Competition",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    }
  ],
  "paramKey": "competition_survey",
  "primaryKey": "id"
}

/** Frontend model for CompetitionSurvey. */
export default class CompetitionSurvey extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  competitionId() {
    return this.readAttributeUnderscore("competition_id")
  }

  /** @returns {boolean} */
  hasCompetitionId() {
    const value = this.competitionId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  forIndividuals() {
    return this.readAttributeUnderscore("for_individuals")
  }

  /** @returns {boolean} */
  hasForIndividuals() {
    const value = this.forIndividuals()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  forTeams() {
    return this.readAttributeUnderscore("for_teams")
  }

  /** @returns {boolean} */
  hasForTeams() {
    const value = this.forTeams()

    return this._isPresent(value)
  }

  /** @returns {string} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  iconPath() {
    return this.readAttributeUnderscore("icon_path")
  }

  /** @returns {boolean} */
  hasIconPath() {
    const value = this.iconPath()

    return this._isPresent(value)
  }

  /** @returns {import("./competition.js").default | null} */
  competition() {
    return this._readBelongsToReflection({modelClass: Competition, reflectionName: "competition"})
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  loadCompetition() {
    if (!("competitionId" in this)) throw new Error("Foreign key method wasn't defined: competitionId")

    const id = this.competitionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "competition",
        model: this,
        modelClass: Competition
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  ensureCompetitionLoaded() {
    return this.ensureAssociationLoaded("competition")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }
}
